// extracted by mini-css-extract-plugin
export var errorIcon = "_pd-1";
export var nameLogo = "_pd-0";